export function initNavbarScroll() {
  const navbar = document.querySelector('.navbar-public');
  if (!navbar) return;

  const links = navbar.querySelectorAll('a, button');
  const logo = navbar.querySelector('[data-brand-logo]');
  const threshold = 50;

  function update() {
    const scrolled = window.scrollY > threshold;
    navbar.classList.toggle('navbar-scrolled', scrolled);
    navbar.classList.toggle('navbar-transparent', !scrolled);
  }

  update();
  window.addEventListener('scroll', update, { passive: true });

  initMobileMenu();
  initBottomSheet();
}

function initMobileMenu() {
  const toggleBtns = document.querySelectorAll('[data-mobile-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  const backdrop = menu ? menu.querySelector('[data-mobile-menu-backdrop]') : null;

  if (!toggleBtns.length || !menu) return;

  function open() {
    menu.classList.remove('hidden');
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        menu.classList.add('menu-open');
      });
    });
    document.body.classList.add('overflow-hidden');
  }

  function close() {
    menu.classList.remove('menu-open');
    document.body.classList.remove('overflow-hidden');
    setTimeout(() => {
      if (!menu.classList.contains('menu-open')) {
        menu.classList.add('hidden');
      }
    }, 300);
  }

  toggleBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      if (menu.classList.contains('hidden')) open(); else close();
    });
  });

  if (backdrop) backdrop.addEventListener('click', close);

  menu.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', close);
  });
}

function initBottomSheet() {
  const sheet = document.querySelector('[data-bottom-sheet]');
  if (!sheet) return;

  const toggleBtns = sheet.querySelectorAll('[data-bottom-sheet-toggle]');
  const content = sheet.querySelector('[data-bottom-sheet-content]');
  const icon = sheet.querySelector('[data-sheet-icon]');
  let isOpen = false;

  toggleBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      isOpen = !isOpen;
      content.classList.toggle('hidden', !isOpen);
      if (icon) {
        icon.classList.toggle('fa-chevron-up', !isOpen);
        icon.classList.toggle('fa-chevron-down', isOpen);
      }
    });
  });
}
